/**
 * AuditoriaTransfolhaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {AuditoriaTransfolha} from '@/model/resource/AuditoriaTransfolha'

/* TODO: review generated class */
@HttpExclude()
export class AuditoriaTransfolhaCollection extends PageCollection<
  AuditoriaTransfolha
> {
  constructor() {
    super(AuditoriaTransfolha)
  }

  queryAsPage() {
    return this.listAuditoriaTransfolha()
  }

  async listAuditoriaTransfolha() {
    return await Request.get(`/admin/auditoria-transfolha`, {
      params: this.params,
    })
      .name('listAuditoriaTransfolha')
      .as(this)
      .getResponse()
  }

  async listCsvAuditoriaTransfolha() {
    return await Request.get(`/admin/auditoria-transfolha/csv`, {
      params: this.params,
    })
      .name('listCsvAuditoriaTransfolha')
      .as(this)
      .getResponse()
  }
}
